/**
 * This handles adding new Alfa Sinapsi device
 */
export class AlfaSinapsiDevice {
  public alfaMqttIP: string = "";
  public alfaMqttPort: string = "";
  public alfaMqttUsername: string = "";
  public alfaMqttPassword: string = "";
  public alfaMqttClientID: string = "";
  public alfaMqttSSLTLS: boolean = false;
  public alfaDescription: string = "";
  public alfaActivationKey: string = "";

  constructor(alfaSinapsiDevices: any) {
    if (alfaSinapsiDevices) {
      Object.assign(this, alfaSinapsiDevices);
    }
  }
}
